import { FC } from 'react';
import { TaskCenterQueries } from '@frontend/api-task-center';
import { DashboardWidget } from '@frontend/grid-dashboard';
import { useAppScopeStore } from '@frontend/scope';
import { useDashboardWidgetStore } from '../../../provider/dashboard-provider/dashboard-widget.provider';
import { widgetContent } from './styles';
import { TaskCount } from './task-count';
import { TaskList } from './task-list';

export const WidgetContent: FC = () => {
  const { selectedLocationIds } = useAppScopeStore();
  const { status, timeWindow } = useDashboardWidgetStore(['timeWindow', 'status']);

  const query = TaskCenterQueries.useGetWidgetTasksList({
    status,
    timeWindow,
    locationId: selectedLocationIds,
  });

  const taskCount = query.data?.pages?.[0]?.totalTasksCount ?? 0;
  const isEmptyState = !query.isLoading && (query.isError || taskCount === 0);

  return (
    <DashboardWidget.Content css={widgetContent(isEmptyState)}>
      {(Boolean(taskCount) || query.isLoading) && (
        <TaskCount count={taskCount} status={status} isLoading={query.isLoading} />
      )}
      <TaskList query={query} status={status} />
    </DashboardWidget.Content>
  );
};
